export const DEFAULT_PORT = 33003;
export const LOCALHOST = 'http://127.0.0.1:';
export const MAX_PORT_SEARCH = 20;
export const MAX_POLLING_ERRORS = 3;
export const VERSION_PREFIX = '/v6';
export const SESSION_LASTKNOWN_ID = 'aspera-last-known-session-id';
export const SESSION_LASTKNOWN_KEY = 'aspera-last-known-session-key';
export const SESSION_LASTKNOWN_PORT = 'aspera-last-known-port';
